import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import PhoneInput from "@Shared/components/inputs/phone-input";
import Select2 from "@Shared/components/inputs/select2.vue";
import { REFERRER_TYPE_OPTIONS } from "@Shared/@Utils/constants";
import { validationMixin } from "vuelidate";
import { required, email, alphaNum, maxLength } from "vuelidate/lib/validators";
import ReferrerDetailsLoader from "./referrer-loader/referrer-details-loader.vue";
import { REFERRAL_SOURCE_ENABLED } from "@Broker/@Modules/main/store/account/account-getters";
import { mapGetters } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerDetails",
  components: {
    CollapsibleCard,
    MaterialInput,
    PhoneInput,
    Select2,
    ReferrerDetailsLoader
  },
  mixins: [validationMixin],
  props: {
    referrer: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  validations: {
    givenName: {
      required
    },
    familyName: {
      required
    },
    type: {
      required
    },
    email: {
      email
    },
    referralCode: {
      alphaNum,
      maxLenght: maxLength(35)
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [REFERRAL_SOURCE_ENABLED])), {}, {
    givenName: {
      get() {
        return this.referrer.givenName;
      },
      set(val) {
        this.handleChange("givenName", val);
      }
    },
    familyName: {
      get() {
        return this.referrer.familyName;
      },
      set(val) {
        this.handleChange("familyName", val);
      }
    },
    phoneNumber: {
      get() {
        return this.referrer.phoneNumber;
      },
      set(val) {
        this.handleChange("phoneNumber", val);
      }
    },
    email: {
      get() {
        return this.referrer.email;
      },
      set(val) {
        this.handleChange("email", val);
      }
    },
    type: {
      get() {
        return this.referrer.type;
      },
      set(val) {
        this.handleChange("type", val);
      }
    },
    note: {
      get() {
        return this.referrer.specialNote;
      },
      set(val) {
        this.handleChange("specialNote", val);
      }
    },
    referralCode: {
      get() {
        return this.referrer.referralCode;
      },
      set(val) {
        this.handleChange("referralCode", val);
      }
    },
    active() {
      return this.$options.filters.formatMoneyValueLong(_parseInt(this.referrer.active));
    },
    inactive() {
      return this.$options.filters.formatMoneyValueLong(_parseInt(this.referrer.inactive));
    },
    combined() {
      return this.$options.filters.formatMoneyValueLong(_parseInt(this.referrer.active) + _parseInt(this.referrer.inactive));
    },
    select2Options() {
      return {
        placeholder: this.$t("referrers.actions.selectAReferrerType"),
        dropdownParent: "#referrers-select-container",
        closeOnSelect: true
      };
    },
    referrerTypeOptions() {
      return REFERRER_TYPE_OPTIONS();
    },
    referralSourceEnabled() {
      return this.REFERRAL_SOURCE_ENABLED;
    }
  }),
  methods: {
    handleChange(key, val) {
      if (this.referrer[key] !== val) {
        this.$emit("update:referrer", _objectSpread(_objectSpread({}, this.referrer), {}, {
          [key]: val
        }));
      }
    }
  }
});